import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import useStyles from './ClientSelect.styles';
import useAgent from '../../../common/hooks/useAgent';
import clientAgent from '../../agents/clientAgent';
import SelectField from '../../../common/components/fields/SelectField';
import { ContainerLoader } from '../../../common/components/loaders';

const ClientSelect = ({ disabled }) => {
  const classes = useStyles();
  const [fetchClients, clients, isFetchingClients] = useAgent(clientAgent.fetchClients);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  if (!clients || isFetchingClients) return <ContainerLoader />;

  return (
    <div className={classes.root}>
      <div className={classes.title}>{i18n.t('common.entity.client')}</div>
      <SelectField name="clientId" options={clients.map((client) => ({ value: client.id, label: client.name }))} disabled={disabled} />
    </div>
  );
};

ClientSelect.propTypes = {
  disabled: PropTypes.bool,
};

ClientSelect.defaultProps = {
  disabled: false,
};

export default ClientSelect;
